import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { CommonProperties, CommonStyles } from '../../styles';
import Button from '../Button';
import InputForm from '../InputForm';
import RowView from '../RowView';
import { bxAuthValidate } from '../../store/actions/auth';

const BxAuth = () => {
  const [authNumber, setAuthNumber] = useState('');
  const dispatch = useDispatch();
  const tripSummary = useSelector((state) => state && state.search && state.search.tripSummary);

  const onPressValidate = () => {
    if (authNumber && tripSummary) {
      dispatch(
        bxAuthValidate({
          UserAuthNumber: authNumber,
          DepartRegionId: '0',
          ArrivalRegionId: '0',
          DepartAirportName: tripSummary.AirResponses[0]?.AirLegs[0]?.DepartureAirportCode,
          ArrivalAirportName: tripSummary.AirResponses[0]?.AirLegs[0]?.ArrivalAirportCode,
          RedeemPoints: tripSummary?.AirResponses[0]?.RedeemPoints,
          SelectedAuthNumber: tripSummary?.AirResponses[0]?.SelectedAwardCode,
          AwardType: 'FLIGHT',
        })
      );
    }
  };
  return (
    <View>
      <RowView>
        <InputForm
          placeholder={'Auth Number'}
          styleContainer={CommonStyles.flex1}
          onChangeText={setAuthNumber}
          value={authNumber}
        />
        <Button label="Apply" style={styles.apply} onPress={onPressValidate} />
      </RowView>
    </View>
  );
};

const styles = StyleSheet.create({
  apply: {
    ...CommonProperties.my2,
    ...CommonProperties.mx2,
  },
});

export default BxAuth;
